// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advert-card {
  width: 100%;
  border-radius: 8px;
  padding: 0px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Yatayda yerleştirilen buton ve ana içerik için düzen */
.advert-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 0px;
  margin-top: 0px;
}

/* Responsive font ve element boyutları */
.advert-card h2 {
  font-size: 20px;
  margin: 0;
}

/* Department (Pozisyon) Bilgisi */
.advert-card p {
  font-size: 14px;
  color: gray;
  margin: 0 0 16px 0;
}

/* Skills ve Keywords */
.advert-card .skills-row {
  display: flex;
}

/* Konum, Eğitim, Tecrübe bilgileri */
.advert-card .details-row {
  color: gray;
  font-size: 12px;
  margin-bottom: 0px;
  margin-top: 0px;
}

.advert-card .details-row .icon-text {
  margin-right: 12px;
}

@media (max-width: 768px) {
  /* Tablet ve küçük cihazlar */
  .advert-card h2 {
    font-size: 18px;
  }

  .advert-card p {
    font-size: 13px;
  }

  .advert-card-row {
    align-items: center;
  }

  .advert-card .details-row {
    flex-direction: column;
    font-size: 11px;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  .advert-card .details-row .icon-text {
    margin-bottom: 4px;
  }
}

@media (max-width: 480px) {
  .advert-card h2 {
    font-size: 16px;
  }

  .advert-card p {
    font-size: 12px;
  }

  .advert-card-row {
    align-items: flex-start;
  }

  .advert-card .details-row {
    flex-direction: column;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Listings/Components/AdvertCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF","sourcesContent":[".advert-card {\n  width: 100%;\n  border-radius: 8px;\n  padding: 0px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Yatayda yerleştirilen buton ve ana içerik için düzen */\n.advert-card-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-bottom: 0px;\n  margin-top: 0px;\n}\n\n/* Responsive font ve element boyutları */\n.advert-card h2 {\n  font-size: 20px;\n  margin: 0;\n}\n\n/* Department (Pozisyon) Bilgisi */\n.advert-card p {\n  font-size: 14px;\n  color: gray;\n  margin: 0 0 16px 0;\n}\n\n/* Skills ve Keywords */\n.advert-card .skills-row {\n  display: flex;\n}\n\n/* Konum, Eğitim, Tecrübe bilgileri */\n.advert-card .details-row {\n  color: gray;\n  font-size: 12px;\n  margin-bottom: 0px;\n  margin-top: 0px;\n}\n\n.advert-card .details-row .icon-text {\n  margin-right: 12px;\n}\n\n@media (max-width: 768px) {\n  /* Tablet ve küçük cihazlar */\n  .advert-card h2 {\n    font-size: 18px;\n  }\n\n  .advert-card p {\n    font-size: 13px;\n  }\n\n  .advert-card-row {\n    align-items: center;\n  }\n\n  .advert-card .details-row {\n    flex-direction: column;\n    font-size: 11px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n  }\n\n  .advert-card .details-row .icon-text {\n    margin-bottom: 4px;\n  }\n}\n\n@media (max-width: 480px) {\n  .advert-card h2 {\n    font-size: 16px;\n  }\n\n  .advert-card p {\n    font-size: 12px;\n  }\n\n  .advert-card-row {\n    align-items: flex-start;\n  }\n\n  .advert-card .details-row {\n    flex-direction: column;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
